<template>
    <div class="sorting" v-if="!this.$root.emptyFilters">
        <div>
            {{ this.productsCount }} Results | show
            <div class="select-wrapper">
                <select @change="changePerPage">
                    <option value="12">12</option>
                    <option value="24">24</option>
                    <option value="48">48</option>
                </select>
                <i class="fas fa-chevron-down"></i>
            </div>
        </div>
        <div>
            sort by
            <div class="select-wrapper">
                <select @change="sortBy">
                    <option value="bestsellers">Bestsellers</option>
                    <option value="price_asc">Price low to high</option>
                    <option value="price_desc">Price high to low</option>
                    <option value="name_asc">A - Z</option>
                    <option value="name_desc">Z - A</option>
                </select>
                <i class="fas fa-chevron-down"></i>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ProductListingHeader",
        props: {
            products: Number
        },
        data() {
          return {
              productsCount: 0
          }
        },
        mounted() {
            this.productsCount = this.products;
            this.$root.$on('updateProductCount', value => {
                this.productsCount = value;
            })
        },
        methods: {
            changePerPage: function(e) {
                this.$root.$emit('productsChangePerPage', e.target.value);
            },
            sortBy: function(e) {
                this.$root.$emit('productsSortBy', e.target.value);
            }
        }
    }
</script>